import React, { useEffect } from 'react';
import { $CR } from '@cantarus/redactor-dnn';
import '@cantarus/redactor-dnn/style.css';

import { FieldDataStrings as Strings } from '../../../utils/config';

const FieldDataHtmlEditor = ({ modelKey, fieldKey, fieldName, fieldValue, handleFieldDataTextChange, isPopUp }) => {
    const textAreaId = `td-htmlEditor-${fieldName}_${modelKey}_${fieldKey}${isPopUp ? '_popup' : ''}`;

    useEffect(() => {
        $CR(`#${textAreaId}`,
            fieldValue,
            (content) => {
                handleFieldDataTextChange(fieldName, content);
            }
        );
    }, []);

    return (
        <textarea
            id={textAreaId}
            placeholder={Strings.placeholder}
        />
    );
};

export default FieldDataHtmlEditor;
